/**
 * @flow
 * @relayHash 7ecc4abd5fbb7983b07a291e3625f1c7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DistributorsQueryVariables = {| |};
export type DistributorsQueryResponse = {|
  +allDistributors: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: string,
        +addressLine1: string,
        +addressLine2: ?string,
        +cityStateLine: string,
        +longitude: number,
        +latitude: number,
        +region: {|
          +name: string,
        |},
      |},
    |}>,
  |},
|};
*/


/*
query DistributorsQuery {
  allDistributors {
    edges {
      node {
        id
        name
        addressLine1
        addressLine2
        cityStateLine
        longitude
        latitude
        region {
          name
          id
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "addressLine1",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "addressLine2",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cityStateLine",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "longitude",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "latitude",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "DistributorsQuery",
  "id": null,
  "text": "query DistributorsQuery {\n  allDistributors {\n    edges {\n      node {\n        id\n        name\n        addressLine1\n        addressLine2\n        cityStateLine\n        longitude\n        latitude\n        region {\n          name\n          id\n        }\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "DistributorsQuery",
    "type": "LarkSeedsAPI",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "allDistributors",
        "storageKey": null,
        "args": null,
        "concreteType": "DistributorConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "DistributorEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Distributor",
                "plural": false,
                "selections": [
                  v0,
                  v1,
                  v2,
                  v3,
                  v4,
                  v5,
                  v6,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "region",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Region",
                    "plural": false,
                    "selections": [
                      v1
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "DistributorsQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "allDistributors",
        "storageKey": null,
        "args": null,
        "concreteType": "DistributorConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "DistributorEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Distributor",
                "plural": false,
                "selections": [
                  v0,
                  v1,
                  v2,
                  v3,
                  v4,
                  v5,
                  v6,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "region",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Region",
                    "plural": false,
                    "selections": [
                      v1,
                      v0
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
(node/*: any*/).hash = '8723e78a55c6c84d719464cbe0647566';
module.exports = node;



// WEBPACK FOOTER //
// ./src/views/Distributors/__generated__/DistributorsQuery.graphql.js